import { UiThemeProvider } from '@jfs/ui-new'
import { LaunchPopup } from './LaunchPopup'
import { AppStack } from './nav/RootNav'

function App() {
  return (
    <UiThemeProvider initialThemeName="light">
      <>
        <AppStack />
        <LaunchPopup />
      </>
    </UiThemeProvider>
  )
}

export { App }
